import axios from 'axios'
import _ from 'lodash'
import * as types from '../mutation-types'

// namespaced
export const namespaced = true

// state
export const state = {
  msg: null,
  deliveryInfo: {
    msg: '',
    location: null,
    distance: 0,
    delivery_plu: null
  },
  address: {
    id: '',
    title: '',
    postal_code: '',
    floor_unit: '',
    block_no: '',
    road_name: '',
    building: '',
    country: 'SINGAPORE',
    contact_name: '',
    contact_no: '',
    cutlery: '',
    remarks: ''
  }
}

// getters
export const getters = {
  deliveryMsg: state => state.msg,
  deliveryInfo: state => state.deliveryInfo,
  isDeliverable: state => !!((state.deliveryInfo && state.deliveryInfo.location)),
  address: state => state.address,
  addressString: state => {
    return (state.address.block_no ? state.address.block_no + ' ' : '') +
          (state.address.road_name ? state.address.road_name + ' ' : '') +
          (state.address.building ? state.address.building + ' ' : '') +
          (state.address.floor_unit && state.address.floor_unit !== '-' ? state.address.floor_unit + ' ' : '') +
          (state.address.postal_code ? state.address.postal_code + ' ' : '') +
          (state.address.country ? state.address.country : '')
  }
}

// mutations
export const mutations = {
  [types.RESET_DELIVERY_DATA] (state) {
    Object.assign(state, {
      msg: null,
      deliveryInfo: {
        msg: '',
        location: null,
        distance: 0,
        delivery_plu: null
      },
      address: {
        id: '',
        title: '',
        postal_code: '',
        floor_unit: '',
        block_no: '',
        road_name: '',
        building: '',
        country: 'SINGAPORE',
        contact_name: '',
        contact_no: '',
        cutlery: '',
        remarks: ''
      }
    })
  },

  [types.SET_DELIVERY_MSG] (state, msg) {
    const msgs = {
      delivery: 'Failed to fetch delivery data',
      delivery2: 'Failed to save delivery data'
    }
    const message = msg ? (msgs[msg] ? msgs[msg] : msg) : 'Failed to fetch data'
    state.msg = message
  },

  [types.RESET_DELIVERY_MSG] (state) {
    state.msg = null
  },

  [types.RESET_ADDRESS] (state) {
    state.address = {
      id: '',
      title: '',
      postal_code: '',
      floor_unit: '',
      block_no: '',
      road_name: '',
      building: '',
      country: 'SINGAPORE',
      contact_name: '',
      contact_no: '',
      cutlery: '',
      remarks: ''
    }
  },

  [types.SET_ADDRESS] (state, address) {
    state.address = {
      id: address.id ? address.id : '',
      title: address.title ? address.title : '',
      postal_code: address.postal_code ? address.postal_code : '',
      floor_unit: address.floor_unit ? address.floor_unit : '',
      block_no: address.block_no ? address.block_no : '',
      road_name: address.road_name ? address.road_name : '',
      building: address.building ? address.building : '',
      country: 'SINGAPORE',
      contact_name: address.contact_name,
      contact_no: address.contact_no,
      cutlery: address.cutlery ? address.cutlery : '',
      remarks: address.remarks ? address.remarks : ''
    }
  },

  [types.SET_ADDRESS_REMARKS] (state, remarks) {
    state.address = {
      id: state.address.id ? state.address.id : '',
      title: state.address.title ? state.address.title : '',
      postal_code: state.address.postal_code ? state.address.postal_code : '',
      floor_unit: state.address.floor_unit ? state.address.floor_unit : '',
      block_no: state.address.block_no ? state.address.block_no : '',
      road_name: state.address.road_name ? state.address.road_name : '',
      building: state.address.building ? state.address.building : '',
      country: 'SINGAPORE',
      contact_name: state.address.contact_name,
      contact_no: state.address.contact_no,
      cutlery: state.address.cutlery ? state.address.cutlery : '',
      remarks: remarks
    }
  },

  [types.SET_ADDRESS_CUTLERY] (state, cutlery) {
    state.address = {
      id: state.address.id ? state.address.id : '',
      title: state.address.title ? state.address.title : '',
      postal_code: state.address.postal_code ? state.address.postal_code : '',
      floor_unit: state.address.floor_unit ? state.address.floor_unit : '',
      block_no: state.address.block_no ? state.address.block_no : '',
      road_name: state.address.road_name ? state.address.road_name : '',
      building: state.address.building ? state.address.building : '',
      country: 'SINGAPORE',
      contact_name: state.address.contact_name ? state.address.contact_name : '',
      contact_no: state.address.contact_no ? state.address.contact_no : '',
      cutlery: cutlery,
      remarks: state.address.remarks
    }
  },

  [types.SET_DELIVERY_INFO] (state, payload) {
    state.deliveryInfo = {
      msg: payload.msg,
      location: payload.location,
      distance: payload.distance,
      delivery_plu: payload.delivery_plu
    }
  },

  [types.RESET_DELIVERY_INFO] (state, payload) {
    state.deliveryInfo = {
      msg: payload || '',
      location: null,
      distance: 0,
      delivery_plu: null
    }
  },

  [types.SET_DELIVERY_PLU] (state, payload) {
    state.deliveryInfo.delivery_plu = payload
  },

  [types.RESET_DELIVERY_PLU] (state) {
    state.deliveryInfo.delivery_plu = null
  }
}

// actions
export const actions = {
  resetDeliveryData ({ commit }) {
    commit(types.RESET_DELIVERY_DATA)
  },

  async fetchDeliveryInfo ({ commit, rootGetters }, payload) {
    commit(types.RESET_DELIVERY_MSG)
    const rid = parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid'])
    try {
      const { data } = await axios.post('/api/restaurant/deliveryinfo', {
        restaurant_id: rid,
        postal_code: payload
      })
      if (data.code === 1) {
        const userLocation = data.data.user_location
        commit(types.SET_DELIVERY_INFO, {
          msg: 'Delivery is available at your area!',
          location: {
            postal_code: userLocation.POSTAL ? userLocation.POSTAL : '',
            block_no: userLocation.BLK_NO ? userLocation.BLK_NO : '',
            road_name: userLocation.ROAD_NAME ? userLocation.ROAD_NAME : '',
            building: userLocation.BUILDING ? userLocation.BUILDING : '',
            country: 'SINGAPORE'
          },
          distance: parseInt(data.data.distance),
          delivery_plu: data.data.delivery_plu
        })
      } else if (data.msg) {
        const msg = data.msg ? data.msg : 'delivery'
        commit(types.RESET_DELIVERY_INFO, msg)
      }
    } catch (e) {
      commit(types.RESET_DELIVERY_INFO)
    }
  },

  resetDeliveryInfo ({ commit }) {
    commit(types.RESET_DELIVERY_INFO)
  },

  resetAddress ({ commit }) {
    commit(types.RESET_ADDRESS)
  },

  setAddress ({ commit, state }, payload) {
    if (!payload) {
      if (state.deliveryInfo.location) {
        commit(types.SET_ADDRESS, state.deliveryInfo.location)
      } else {
        commit(types.RESET_ADDRESS)
      }
    } else {
      commit(types.SET_ADDRESS, {
        id: payload.id,
        title: payload.title,
        postal_code: payload.postal_code,
        floor_unit: payload.floor_unit,
        block_no: payload.block_no,
        road_name: payload.road_name,
        building: payload.building,
        country: 'SINGAPORE',
        contact_name: payload.contact_name,
        contact_no: payload.contact_no,
        remarks: state.address.remarks,
        cutlery: state.address.cutlery
      })
    }
  },

  setAddressRemarks ({ commit, state }, payload) {
    commit(types.SET_ADDRESS_REMARKS, payload)
  },

  setAddressCutlery ({ commit, state }, payload) {
    commit(types.SET_ADDRESS_CUTLERY, payload)
  },

  async fetchDeliveryPlu ({ commit, state, rootGetters }) {
    commit(types.RESET_DELIVERY_MSG)
    const rid = parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid'])
    try {
      const { data } = await axios.post('/api/restaurant/deliveryplu', {
        restaurant_id: rid,
        postal_code: state.address.postal_code,
        cart_qty: parseInt(rootGetters['cart/cartQty']),
        cart_total: parseFloat(rootGetters['cart/cartAmount'])
      })
      if (data.code === 1) {
        commit(types.SET_DELIVERY_PLU, data.data.delivery_plu)
      } else {
        const msg = data.msg ? data.msg : 'delivery'
        commit(types.RESET_DELIVERY_PLU)
        commit(types.SET_DELIVERY_MSG, msg)
      }
    } catch (e) {
      commit(types.RESET_DELIVERY_PLU)
      commit(types.SET_DELIVERY_MSG, 'delivery')
    }
  },

  async fetchPresetItem ({ commit, state, rootGetters, dispatch }) {
    const rid = parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid'])
    const date = rootGetters['cart/pickupDate']
    const { data } = await axios.post('/api/restaurant/deliveryPresetItem', {
      rid: rid,
      date: date
    })
    if (data.item_id) {
      const formatData = {
        category_id: data.category_id,
        category_name: data.category_name,
        item_id: data.item_id,
        name: data.item_name,
        plu_id: data.plu_id,
        price: data.price || data.plu_price,
        price_override: data.price_override || 0,
        priceow: data.price_override || 0,
        quantity: 1,
        qty: 1, // Accepted by POS
        tax: data.tax,
        pluID: data.plu_id, // Accepted by POS
        setCourseItemID: data.course_item_id || '', // Accepted by POS
        service_charge: data.service_charge,
        time_required: data.time_required || '',
        tray_count: 0,
        is_set_meal: 0,
        non_discount: data.non_discount || 0,
        photo_url: '',
        courseLevel: data.level || 0,
        isItemSetMeal: data.isItemSetMeal || 0,
        alternativeName: data.alternate_name || data.name
      }
      const params = {
        item: JSON.parse(JSON.stringify(formatData)),
        quantity: 1,
        final_price: parseFloat(data.price_override || data.price || data.plu_price),
        is_auto_preset: true
      }
      await dispatch('cart/addCartItem', params, { root: true })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/delivery.js